package com.evoapps.evoshift.location

import androidx.compose.runtime.Composable
import com.evoapps.evoshift.domain.model.GeoLocation
import com.evoapps.evoshift.domain.model.LocationReading
import com.evoapps.evoshift.domain.model.LocationUnavailable
import kotlinx.browser.localStorage
import kotlinx.browser.window
import kotlinx.coroutines.suspendCancellableCoroutine
import kotlinx.coroutines.withTimeoutOrNull
import kotlin.coroutines.resume

/** The browser's Geolocation API, once: the browser asks the person the first time. */
@Composable
actual fun rememberPlatformLocationReader(): LocationReader = ::readBrowserLocation

private suspend fun readBrowserLocation(): LocationReading {
    val geolocation: dynamic = window.navigator.asDynamic().geolocation
    if (geolocation == null || geolocation == undefined) return LocationReading.Unavailable(LocationUnavailable.UNSUPPORTED)
    return withTimeoutOrNull(LOCATION_TIMEOUT_MILLIS + 1_000) {
        suspendCancellableCoroutine { cont ->
            val options: dynamic = js("({})")
            options.enableHighAccuracy = true
            options.timeout = LOCATION_TIMEOUT_MILLIS.toInt()
            options.maximumAge = 30_000
            geolocation.getCurrentPosition(
                { position: dynamic ->
                    val coords = position.coords
                    val location = GeoLocation.of((coords.latitude as Number).toDouble(), (coords.longitude as Number).toDouble())
                    val reading = if (location == null) LocationReading.Unavailable(LocationUnavailable.NO_FIX)
                    else LocationReading.Fix(location, (coords.accuracy as? Number)?.toDouble())
                    if (cont.isActive) cont.resume(reading)
                },
                { error: dynamic ->
                    // 1 PERMISSION_DENIED, 2 POSITION_UNAVAILABLE, 3 TIMEOUT.
                    val reason = if ((error.code as? Number)?.toInt() == 1) LocationUnavailable.DENIED else LocationUnavailable.NO_FIX
                    if (cont.isActive) cont.resume(LocationReading.Unavailable(reason))
                },
                options
            )
        }
    } ?: LocationReading.Unavailable(LocationUnavailable.NO_FIX)
}

/** localStorage can be missing or throw (private windows): then the notice shows again next time. */
actual fun platformLocationNoticeStore(): LocationNoticeStore = object : LocationNoticeStore {
    override fun isAcknowledged(): Boolean = runCatching { localStorage.getItem(LOCATION_NOTICE_KEY) == "1" }.getOrDefault(false)
    override fun acknowledge() {
        runCatching { localStorage.setItem(LOCATION_NOTICE_KEY, "1") }
    }
}
